"use client"
export const ButtonInfoElements = ({ children }) => <div className={`flex flex-col gap-10 md:gap-[48px]`}>{children}</div>
